import { useFormContext } from "react-hook-form";
import { FieldValidator } from "./Form";
import { useContext } from "react";
import { disabledInputClasses, inputClasses } from "./InputField";
import { LangContext, LangContextType } from "../../utilities/customHooks";
import textData from "../../textData.json";
import { RadioGroup, RadioGroupItem } from "@components/ui/radio-group";
import { Label } from "@components/ui/label";

export default function BooleanSelect(
  {
    name,
    value,
    setValue,
    isViewOnly,
    disabled,
    readOnly,
    validator,
  }
  :
  {
    name: string,
    value: boolean | null,
    setValue: (value: boolean) => void,
    isViewOnly?: boolean,
    disabled?: boolean,
    readOnly?: boolean,
    validator?: FieldValidator,
  }
) {
  const { langState } = useContext(LangContext) as LangContextType

  const { register, clearErrors } = useFormContext();

  const handleValueChange = (newValue: string) => {
    setValue(newValue === "yes");
    clearErrors(name);
  }

  const radioValue = value === true ? "yes" : value === false ? "no" : "";

  return (
    isViewOnly
    ?
    <fieldset className="flex text-text">
      <label
        className={`pl-2 ${inputClasses} ${(disabled || readOnly) ? disabledInputClasses : "" }`}
      >
        {value === true ? textData.Components.Form.BooleanSelect.Yes[langState] : value === false ? textData.Components.Form.BooleanSelect.No[langState] : textData.Components.Form.BooleanSelect.NotSelected[langState]}
      </label>
    </fieldset>
    :
    <fieldset className="flex text-text">
      {/* Hidden input for react-hook-form registration/validation */}
      <input
        type="hidden"
        {...register(name, {
          validate: () => {
            if (value === null) {
              return textData.Components.Form.BooleanSelect.MakeSelection[langState];
            }
            return true;
          },
        })}
      />
      <RadioGroup
        value={radioValue}
        onValueChange={handleValueChange}
        disabled={disabled || readOnly}
        className="flex flex-row items-center gap-4"
      >
        <div className="flex items-center gap-2">
          <RadioGroupItem
            value="yes"
            id={`${name}-yes`}
          />
          <Label
            htmlFor={`${name}-yes`}
            className="cursor-pointer font-normal"
          >
            {textData.Components.Form.BooleanSelect.Yes[langState]}
          </Label>
        </div>
        <div className="flex items-center gap-2">
          <RadioGroupItem
            value="no"
            id={`${name}-no`}
          />
          <Label
            htmlFor={`${name}-no`}
            className="cursor-pointer font-normal"
          >
            {textData.Components.Form.BooleanSelect.No[langState]}
          </Label>
        </div>
      </RadioGroup>
    </fieldset>
  )
}
